export const typeDeclarations = `
interface Array<T> {
	[Symbol.unscopables](): {};
}

interface Array<T> {
    [n: number]: T;
}

interface Function {
    prototype: any;
}

interface Number {
}

interface String {
	_: any
}

interface text extends String {}
interface date {}
interface datetime {}
interface TIMESTAMP {}
interface timestamp {}
interface geo {}
interface jsonobject {}
`;
